import env from 'env'

import { Api, MIME_TYPE } from '../'
import { HTTP_METHOD } from '../../../constants/enums'

export class PlaybackApi extends Api {
  version = 'v1'
}

export class PlaybackSessionApi extends PlaybackApi {
  version = '1.0'
  origin = env.ENTRY_BASE_URL
  baseUrl = env.PLAYBACK_SESSION_BASE_URL // override for phish only

  async fetchToken(token: string | null, uguid: string, userId: number | null) {
    try {
      if (!userId || !uguid) return null

      this.headers.set('Content-Type', MIME_TYPE.JSON)

      const response = await this.fetch('sessions', HTTP_METHOD.POST, {
        playbackToken: token,
        userGuid: uguid,
        userId: userId,
        platform: 'web'
      }, {
        mode: 'cors'
      })

      if (response.ok) {
        const { playbackToken } = await response.json()
        return playbackToken
      } else {
        return null
      }
    } catch {
      return null
    }
  }
}
